import { createSlice } from '@reduxjs/toolkit'
import { register } from '../../../../../../../../../helpers/reducerRegistry'
import { convertDataTable, getListId } from '../helper'
import { downloadLinkageScore, getLinkageScore } from './thunk'

const initialState = {
  ids: [],
  data: {},
  dataRaw: [],
  idsRaw: [],
  loading: {
    linkageScore: false,
  },
  filter: {
    sortBy: 'relationship',
    sortDirection: 'Ascending',
  },
}
const slice = createSlice({
  name: 'companyAnalysis/scoreCompany/CorporateLinkageScore',
  initialState: initialState,
  reducers: {
    changeFilter: (state, action) => {
      state.filter = { ...state.filter, ...action.payload }
    },
    changeIds: (state, action) => {
      state.ids = action.payload
    },
    resetStoreLinkage(state) {
      Object.keys(initialState).forEach((key) => {
        state[key] = initialState[key]
      })
    },
  },
  extraReducers: (builder) => {
    //get LinkageScore
    builder.addCase(getLinkageScore.pending, (state, action) => {
      state.loading.linkageScore = true
    })
    builder.addCase(getLinkageScore.fulfilled, (state, action) => {
      state.ids = getListId(action.payload)
      state.idsRaw = getListId(action.payload)
      state.dataRaw = action.payload
      state.data = action.payload
        ? convertDataTable(action.payload)
        : initialState['getHightLightData']
      state.loading.linkageScore = false
    })
    builder.addCase(getLinkageScore.rejected, (state, action) => {
      state.loading.linkageScore = action.payload.loading
    })
    //downloadLinkageScore
    builder.addCase(downloadLinkageScore.pending, (state, action) => {
      state.loading.download = true
    })
    builder.addCase(downloadLinkageScore.fulfilled, (state, action) => {
      state.loading.download = false
    })
    builder.addCase(downloadLinkageScore.rejected, (state, action) => {
      state.loading.download = false
    })
  },
})

export const selectIdsTable = (state) => state[slice.name]?.ids
export const selectIdsRawTable = (state) => state[slice.name]?.idsRaw
export const selectDataRawTable = (state) => state[slice.name]?.dataRaw
export const getDataReduxTable = (rowId, colId) => (state) => {
  return state[slice.name].data[rowId][colId]
}
//loading
export const selectLoadingTable = (state) =>
  state[slice.name]?.loading.linkageScore
export const selectLoadingDownload = (state) =>
  state[slice.name]?.loading.download

export const selectFilter = (state) => state[slice.name].filter

export const { changeFilter, changeIds, resetStoreLinkage } = slice.actions

register(slice.name, slice.reducer)
